import { useCallback, useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import Ripples from "react-ripples";
import { IconController } from "../../../../Scripts/ImgController";
import assets from "../../../../../assets/assets";

const FileUpload = ({
  borderType = "solid",
  icon,
  onImageSelected,
  required = false,
  errorMessage = "This field is required",
}) => {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const fileUrl = URL.createObjectURL(file);
        setPreview(fileUrl);
        onImageSelected(fileUrl);
        setError(null);
      }
    },
    [onImageSelected]
  );

  const handleOnChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = function (e) {
        onImageSelected(reader.result);
        setPreview(reader.result);
        required = { required };
        setError(errorMessage);
      };
    }
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: {
      "image/svg+xml": [".svg"],
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/gif": [".gif"],
    },
    maxSize: 800 * 400,
    noClick: true,
  });

  return (
    <div
      className={`relative w-full flex items-center justify-center gap-4 rounded-[20px] aspect-video
        border border-[#E4E7EC] overflow-hidden cursor-pointer ${
          borderType === "dashed"
            ? "border-dashed max-w-[360px] max-h-[180px]"
            : "border-solid max-h-28"
        }  ${!preview ? "px-6 py-4" : ""}`}
      onClick={open}
    >
      <div
        {...getRootProps()}
        className={`flex items-center gap-3 ${
          borderType === "dashed" ? "flex-col" : "flex-row"
        }`}
      >
        <input {...getInputProps()} />
        <Ripples
          color="#FFFFFF40"
          during={600}
          className="rounded-full"
          onClick={open}
        >
          <div className="p-2.5 bg-[#DEF0FC] rounded-full cursor-pointer outline-none">
            <IconController
              src={icon || assets.svg.addImage}
              alt="Upload Icon"
              className="h-5 w-5"
            />
          </div>
        </Ripples>

        <p className="text-[#475467] text-xs text-center leading-5">
          <span className="text-[#004AC4] font-semibold text-sm">
            Click to upload{" "}
          </span>
          or drag and drop <br /> PNG, JPG (min. 800x400px)
        </p>
      </div>

      {/* Hidden file input */}
      <input
        required
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleOnChange}
      />
      {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
    </div>
  );
};

export const ImageDisplay = ({ imgAfterCrop, borderType, setCurrentPage }) => {
  return (
    <div
      className={`relative w-full flex items-center justify-center gap-4 rounded-[20px] aspect-video
    border border-[#E4E7EC] overflow-hidden ${
      borderType === "dashed"
        ? "border-dashed max-w-[335px] max-h-[180px]"
        : "border-solid max-h-28"
    } group`}
    >
      {imgAfterCrop ? (
        <div
          className={`${
            borderType === "dashed"
              ? "max-w-[360px] w-full h-full"
              : "max-w-[510px] max-h-28"
          } w-full rounded-[20px] overflow-hidden`}
        >
          <img
            src={imgAfterCrop.url}
            alt="Cropped"
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <p className="text-red-500">⚠️ Image not available</p>
      )}
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition">
        <button
          onClick={() => setCurrentPage("crop-img")}
          className="p-2 bg-white rounded-full shadow-sm"
        >
          <IconController
            src={assets.svg.editPen}
            alt="Mmusic Logo"
            className="h-5 w-5"
          />
        </button>
      </div>
    </div>
  );
};

export default FileUpload;
